export enum LOCALE_PARAMS {
  pt_br = 'pt-BR',
  en_us = 'en-US',
  es_es = 'es-ES',
  ar = 'ar',
  fr = 'fr-FR',
}

export enum KEYBOARD_SHORTCUTS {
  TOGGLE_FULLSCREEN = 'f',
  TOGGLE_PLAY = ' ',
  TOGGLE_PLAY_ALTERNATIVE = 'k',
  TOGGLE_SUBTITLE = 'c',
  FORWARD = 'ArrowRight',
  BACKWARD = 'ArrowLeft',
  RAISE_VOLUME = 'ArrowUp',
  REDUCE_VOLUME = 'ArrowDown',
}

export enum NAVIGATION_KEYS {
  ARROW_RIGHT = 'ArrowRight',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ESCAPE = 'Escape',
  ENTER = 'Enter',
  SPACE = ' ',
}

export enum POST_MESSAGE_EVENTS {
  ADD_CUE = 'ADD_CUE',
  REMOVE_CUE = 'REMOVE_CUE',
  CHANGEVIDEO = 'CHANGEVIDEO',
  ENDED = 'ENDED',
  SET_PLAYER_TIME = 'SET_PLAYER_TIME',
}

export enum PAGE_EVENTS {
  BEFOREUNLOAD = 'BEFOREUNLOAD',
}

export enum ENVIRONMENTS {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
}

export enum EVENT_TYPES {
  FIRST_PLAY = 'FIRSTPLAY',
  PLAY = 'PLAY',
  PAUSE = 'PAUSE',
  SEEK_INIT = 'SEEKINIT',
  SEEKING = 'SEEKING',
  SEEK_ENDED = 'SEEKENDED',
  WAITING = 'WAITING',
  CAN_PLAY = 'CANPLAY',
  FULLSCREEN_CHANGE = 'FULLSCREENCHANGE',
  RATE_CHANGE = 'RATECHANGE',
  ADD_TRACK = 'ADDTRACK',
  SUBTITLE_CHANGE = 'SUBTITLECHANGE',
  RESOLUTION_CHANGE = 'RESOLUTIONCHANGE',
  CONTEXT_MENU = 'CONTEXTMENU',
  LOADED_METADATA = 'LOADEDMETADATA',
  TIME_UPDATE = 'TIMEUPDATE',
  READY = 'READY',
  ENDED = 'ENDED',
  CLICK = 'CLICK',
  TOUCHSTART = 'TOUCHSTART',
  CHANGEVIDEO = 'CHANGEVIDEO',
  ERROR = 'ERROR',
  ENTERPICTUREINPICTURE = 'ENTERPICTUREINPICTURE',
  LEAVEPICTUREINPICTURE = 'LEAVEPICTUREINPICTURE',
  USER_ACTIVE = 'USERACTIVE',
  USER_INACTIVE = 'USERINACTIVE',
  VOLUME_CHANGE = 'VOLUMECHANGE',
}

export enum DRM_PROVIDERS {
  WIDEVINE = 'com.widevine.alpha',
  PLAYREADY = 'com.microsoft.playready',
  APPLE_FPS = 'com.apple.fps.1_0',
  FAIRPLAY = 'com.apple.fairplay',
}

export enum EXTENSION_TYPES {
  HLS = '.m3u8',
  DASH = '.mpd',
}

export enum STORAGE_ITEMS {
  STORAGE_TEST = 'storage.test',
  AUTOPLAY_ENABLED = 'autoplay.enabled',
  VOLUME = 'volume',
  MARKER_PREVIEW_ENABLED = 'markerPreview.enabled',
  SUBTITLE = 'subtitle',
  PLAYBACK_RATE = 'playbackRate',
}

export enum MARKER_STATUS {
  CLOSED = 'CLOSED',
  SHOWING = 'SHOWING',
  EDITING = 'EDITING',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
}

export enum MARKER_ACTION {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

export enum MARKER_TYPE {
  MARK = 'MARK',
  NOTE = 'NOTE',
}

export enum ANALYTICS_EVENT {
  LOAD_START = 'loadstart',
}

export enum DEVICE_CONNECTION {
  CABLE = 'cable',
  WIRELESS = 'wireless',
}

export enum SCREEN_TYPES {
  mobile = 480,
  tablet = 768,
  desktop = 1200,
  large = 1920,
}

export enum SETTING_CONTAINERS {
  MAIN = 'main',
  RESOLUTION = 'resolution',
  PLAYBACK_RATE = 'speed',
  SUBTITLE = 'subtitle',
  SUBTITLE_STYLE = 'subtitleStyle',
}

export enum PLAYER_THEMES {
  COSMOS = 'cosmos',
}

export enum SUBTITLE_COLOR_OPTIONS {
  yellow = 'yellow',
  white = 'white',
  black = 'black',
}

export enum SUBTITLE_SIZE_OPTIONS {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum SUBTITLE_BACKGROUND_OPTIONS {
  none = 'none',
  white = 'white',
  black = 'black',
}

export enum SUBTITLE_STROKE_OPTIONS {
  light = 'light',
  regular = 'regular',
  strong = 'strong',
}

export enum API_VERSIONS {
  v3 = 'v3',
  v4 = 'v4',
  v5 = 'v5',
}

export enum MEDIA_TYPE {
  audio = 'audio',
  video = 'video',
}

export enum TRANSMISSION_TYPE {
  live = 'live',
  vod = 'vod',
}
